<span *ngIf="name || src" [title]="title">
  <ion-icon [name]="name" [src]="src" [ngClass]="alignmentClass" [style.color]="color"></ion-icon>
</span>
